module.exports = __webpack_public_path__ + "img/hbl2.dc8b1af9.png";